export function defineEntityItemDerivation(args) {
    return args;
}
export function defineConnectorItemDerivation(args) {
    return args;
}
/** Shallow merge, except `visualStyle` and `label` which merge one level deeper. */
export function withMergedEntityItemParametricState(itemDerivation, update) {
    const { parametricState } = itemDerivation;
    return {
        item: itemDerivation.item,
        parametricState: {
            ...parametricState,
            ...update,
            visualStyle: {
                ...(parametricState.visualStyle ?? {}),
                ...(update.visualStyle ?? {}),
            },
            label: {
                ...(parametricState.label ?? {}),
                ...(update.label ?? {}),
            },
        },
    };
}
export function defineEntityItemCollectionDerivation(args) {
    return args;
}
export function defineConnectorItemCollectionDerivation(args) {
    return args;
}
export function defineEntityConstellationDerivation(args) {
    return args;
}
export function defineConnectorConstellationDerivation(args) {
    return args;
}
export function flattenItemDerivations(itemCollectionDerivations) {
    const entityItemByKey = {};
    const connectorItemByKey = {};
    for (const itemCollectionDerivation of itemCollectionDerivations) {
        for (const itemDerivation of itemCollectionDerivation.itemDerivations) {
            if (itemDerivation.item.itemKind === 'entity') {
                entityItemByKey[itemDerivation.item.itemKey] = itemDerivation.parametricState;
                continue;
            }
            connectorItemByKey[itemDerivation.item.itemKey] = itemDerivation.parametricState;
        }
    }
    const hasEntityItems = Object.keys(entityItemByKey).length > 0;
    const hasConnectorItems = Object.keys(connectorItemByKey).length > 0;
    if (!hasEntityItems && !hasConnectorItems)
        return undefined;
    return {
        ...(hasEntityItems ? { entityItemByKey } : {}),
        ...(hasConnectorItems ? { connectorItemByKey } : {}),
    };
}
/** Structural view for consumers that query topology and never need parametric state. */
export function toItemCollections(itemCollectionDerivations) {
    return itemCollectionDerivations.map((itemCollectionDerivation) => {
        // The branches are identical but keep the collection key and kind narrowed together.
        if (itemCollectionDerivation.itemCollectionKind === 'entity') {
            return {
                itemCollectionKey: itemCollectionDerivation.itemCollectionKey,
                itemCollectionKind: itemCollectionDerivation.itemCollectionKind,
                items: itemCollectionDerivation.itemDerivations.map((itemDerivation) => itemDerivation.item),
            };
        }
        return {
            itemCollectionKey: itemCollectionDerivation.itemCollectionKey,
            itemCollectionKind: itemCollectionDerivation.itemCollectionKind,
            items: itemCollectionDerivation.itemDerivations.map((itemDerivation) => itemDerivation.item),
        };
    });
}
export function assembleItemDerivations(itemCollectionDerivations) {
    const itemCollections = toItemCollections(itemCollectionDerivations);
    const itemParametricState = flattenItemDerivations(itemCollectionDerivations);
    return {
        itemCollections,
        ...(itemParametricState === undefined ? {} : { itemParametricState }),
    };
}
export function flattenConstellationDerivations(constellationDerivations) {
    const entityConstellationByKey = {};
    const connectorConstellationByKey = {};
    for (const constellationDerivation of constellationDerivations) {
        const { constellation, parametricState } = constellationDerivation;
        if (constellation.constellationKind === 'entity') {
            entityConstellationByKey[constellation.constellationKey] = parametricState;
            continue;
        }
        if (parametricState !== undefined) {
            connectorConstellationByKey[constellation.constellationKey] = parametricState;
        }
    }
    const hasEntityConstellations = Object.keys(entityConstellationByKey).length > 0;
    const hasConnectorConstellations = Object.keys(connectorConstellationByKey).length > 0;
    if (!hasEntityConstellations && !hasConnectorConstellations)
        return undefined;
    return {
        ...(hasEntityConstellations ? { entityConstellationByKey } : {}),
        ...(hasConnectorConstellations ? { connectorConstellationByKey } : {}),
    };
}
export function assembleConstellationDerivations(constellationDerivations) {
    const constellations = constellationDerivations.map((constellationDerivation) => constellationDerivation.constellation);
    const constellationParametricState = flattenConstellationDerivations(constellationDerivations);
    return {
        constellations,
        ...(constellationParametricState === undefined ? {} : { constellationParametricState }),
    };
}
export function toEntityItemCollectionDerivation(args) {
    return {
        itemCollectionKey: args.itemCollectionKey,
        itemCollectionKind: 'entity',
        itemDerivations: args.itemDerivations,
    };
}
export function toConnectorItemCollectionDerivation(args) {
    return {
        itemCollectionKey: args.itemCollectionKey,
        itemCollectionKind: 'connector',
        itemDerivations: args.itemDerivations,
    };
}
